import { render, staticRenderFns } from "./ShopData.vue?vue&type=template&id=0e7fc70d&"
import script from "./ShopData.vue?vue&type=script&lang=js&"
export * from "./ShopData.vue?vue&type=script&lang=js&"
import style0 from "./ShopData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports